import React, { useRef } from 'react';

const formatBytes = (bytes) => {
  if (!bytes) return '';
  const units = ['B', 'KB', 'MB', 'GB'];
  let value = bytes;
  let unit = 0;
  while (value >= 1024 && unit < units.length - 1) {
    value /= 1024;
    unit += 1;
  }
  return `${value.toFixed(value >= 10 || unit === 0 ? 0 : 1)} ${units[unit]}`;
};

const FormFileUpload = ({
  id,
  name,
  label,
  value,
  onChange,
  error,
  required = false,
  disabled = false,
  accept,
  hint,
  buttonLabel = 'Choose file',
  changeLabel = 'Replace file',
}) => {
  const fieldId = id || name;
  const errorId = error ? `${fieldId}-error` : undefined;
  const hintId = hint ? `${fieldId}-hint` : undefined;
  const describedBy = [errorId, hintId].filter(Boolean).join(' ') || undefined;
  const inputRef = useRef(null);
  const fileName = value?.name || '';
  const fileSize = value ? formatBytes(value.size) : '';

  return (
    <div className={`tf-field${error ? ' tf-field--invalid' : ''}`}>
      {label && (
        <label htmlFor={fieldId} className="tf-field__label">
          {label}{required && <span aria-hidden="true" className="tf-field__required"> *</span>}
        </label>
      )}
      <div className="tf-file">
        <input
          ref={inputRef}
          id={fieldId}
          name={name}
          type="file"
          accept={accept}
          onChange={onChange}
          disabled={disabled}
          required={required && !value}
          aria-invalid={!!error}
          aria-required={required || undefined}
          aria-describedby={describedBy}
          className="tf-file__input"
        />
        <button
          type="button"
          className="tf-file__btn"
          onClick={() => inputRef.current?.click()}
          disabled={disabled}
        >
          {value ? changeLabel : buttonLabel}
        </button>
        <span className="tf-file__name" title={fileName}>
          {fileName ? `${fileName}${fileSize ? ` (${fileSize})` : ''}` : 'No file selected'}
        </span>
      </div>
      {hint && !error && (
        <span id={hintId} className="tf-field__hint">{hint}</span>
      )}
      {error && (
        <span id={errorId} className="tf-field__error" role="alert">{error}</span>
      )}
    </div>
  );
};

export default FormFileUpload;
